export const authRoles = {
  OWNER: ['OWNER'], // Only OWNER has access
  SA: ['SA', 'OWNER'], // Only Super Admin has access
  ADMIN: ['SA', 'ADMIN', 'OWNER'], // Only SA & Admin has access
  DRIVER: ['DRIVER'], // Only SA & Admin & Editor has access
  GUEST: ['SA', 'ADMIN', 'DRIVER', 'GUEST', 'OWNER'], // Everyone has access
};
